import React, { useRef } from 'react';
import { PlusIcon } from '@phosphor-icons/react';
import { useTranslation } from 'react-i18next';
import { I18nNamespace } from '@/lib/i18n-namespaces';
import { Button } from '@/components/ui/Button';
import { QueryPanelState } from '../hooks';
import { getImageAcceptAttribute } from '@/utils/image-validation';
import { RecentQueriesDropdown } from './RecentQueriesDropdown';

interface ActionsProps {
    state: QueryPanelState;
}

export function Actions({ state }: ActionsProps) {
    const { t } = useTranslation(I18nNamespace.QUERIES);
    const { t: tCommon } = useTranslation();
    const fileInputRef = useRef<HTMLInputElement>(null);

    const handleSelectRecentQuery = (query: string) => {
        state.setSearchQuery(query);
        state.inputRef.current?.focus();
    };

    const handleFileSelect = (e: React.ChangeEvent<HTMLInputElement>) => {
        const file = e.target.files?.[0];
        if (!file) return;

        void state.handleAttach({ file });

        if (fileInputRef.current) {
            fileInputRef.current.value = '';
        }
    };

    return (
        <div className="flex items-center gap-1">
            <input
                ref={fileInputRef}
                type="file"
                accept={getImageAcceptAttribute()}
                onChange={handleFileSelect}
                className="hidden"
            />
            <Button
                variant="ghost"
                shape="round"
                size="medium"
                className="size-8 min-w-8 p-0"
                onClick={() => fileInputRef.current?.click()}
                disabled={!!state.attachmentFile}
                leadingIcon={<PlusIcon className="size-4" />}
                aria-label={tCommon('ariaLabels.addAttachment')}
            />
            <RecentQueriesDropdown
                queries={state.recentQueries}
                onSelect={handleSelectRecentQuery}
                onRemove={state.removeRecentQuery}
                onClearAll={state.clearRecentQueries}
                label={t('actions.recents')}
                emptyLabel={t('actions.noRecentQueries')}
                removeLabel={tCommon('button.remove')}
                clearLabel={t('actions.clearAll')}
                triggerClassName="size-8 min-w-8 p-0"
            />
        </div>
    );
}
